// extracted by mini-css-extract-plugin
export default {"bbacklight":"Hero_bbacklight__9MTuV","backlight":"Hero_backlight__1txTt","original":"Hero_original__0mMUv"};